{
  "received_referrals": {
    "grid": {
      "track_referral_header": "Suivre une Recommandation",
      "track_received_referral": "Suivre une Recommandation Reçue",
      "track_received_referral_aria": "suivre une recommandation reçue",
      "export_filename": "recommandations reçues",
      "open_slider_aria": "ouvrir le curseur"
    },
    "create": {
      "track_referral": "SuivreRecommandation"
    },
    "form": {
      "validation": {
        "company_required": "Veuillez saisir une entreprise"
      },
      "labels": {
        "client_company": "Entreprise Cliente (Entreprise Associée) *",
        "client_contact": "Contact Client (Contact Clé)",
        "description": "Description",
        "description_placeholder": "Décrivez votre opportunité en une phrase",
        "opportunity_date": "Date de l'Opportunité",
        "date_placeholder": "date",
        "received_by": "Reçu par (Propriétaire Interne)",
        "received_by_placeholder": "Qui sera responsable de cette opportunité?",
        "sent_by": "Envoyé par (Source de Recommandation)",
        "sent_by_placeholder": "Qui a recommandé cette opportunité?",
        "more_fields": "PLUS DE CHAMPS",
        "status": "Statut",
        "tags": "Étiquettes",
        "proposed_fee": "Honoraires Proposés",
        "team_involved": "Équipe Impliquée",
        "team_involved_placeholder": "Équipe impliquée dans cette opportunité?",
        "opportunity": "Opportunité",
        "referral": "Recommandation",
        "company_search_placeholder": "Tapez pour rechercher une entreprise"
      }
    },
    "loading": {
      "loading_referrals": "Chargement des recommandations",
      "error_prefix": "Erreur: ",
      "load_limit_message": "Tableau des recommandations limité à 10 000 lignes. Contactez-nous pour des données supplémentaires."
    }
  },
  "sent_referral_preview": {
    "header": "Référence envoyée",
    "sent_on": "Envoyé le",
    "sent_to": "Envoyé à",
    "type_of_legal_matter": "Type de dossier juridique",
    "client_contact": "Contact client",
    "client_company": "Société cliente",
    "referred_by_employee": "Référé par l'employé",
    "status": "Statut"
  },
  "result_status_field": {
    "matter_created": "Dossier créé",
    "matter_not_created": "Dossier non créé",
    "matter_pending": "Dossier en attente"
  },
  "sent_referral_form": {
    "track_referral": "Suivre la référence",
    "track_a_referral": "Suivre une référence",
    "update_referral": "Mettre à jour la référence",
    "date": "Date",
    "to": "À",
    "from": "De",
    "client": "Client",
    "client_contact": "Contact client",
    "client_company_placeholder": "Société cliente",
    "type_of_legal_matter": "Type de dossier juridique",
    "did_result_in_matter": "Cette référence a-t-elle abouti à un dossier ?",
    "track_referral_button": "Suivre la référence",
    "please_choose_date": "Veuillez choisir la date",
    "please_add_contact": "Veuillez ajouter un contact",
    "contact_name_placeholder_from": "Nom du contact",
    "client_contact_placeholder": "Nom du contact",
    "update_sent_referral_aria_label": "mettre à jour la référence envoyée"
  },
  "delete_sent_referral": {
    "label": "supprimer la référence envoyée",
    "confirm_title": "Êtes-vous sûr de vouloir supprimer cette référence envoyée ?"
  },
  "sent_referrals_list": {
    "error": "Erreur : {{message}}",
    "load_limit": "Tableau des références limité à 10 000 lignes. Contactez-nous pour plus de données."
  },
  "sent_referral_grid": {
    "file_name": "références envoyées",
    "audit_primary_name": "vue des références envoyées",
    "audit_secondary_name": "toutes les références envoyées"
  },
  "sent_referral_actions": {
    "open_slider": "ouvrir le volet"
  }
}
